<template>
  <v-dialog v-model="showDialog" persistent max-width="510">
    <v-card>
      <v-card-title class="text-h3">
        {{ $t('TARIFF_STEP_CHANGE_OFFER_TYPE_TITLE', { offerType }) }}
      </v-card-title>
      <v-card-text class="text-body-2">
        {{ $t('TARIFF_STEP_CHANGE_OFFER_TYPE_DESC', { offerType }) }}
      </v-card-text>
      <v-card-actions class="pb-4 pr-8">
        <v-spacer />
        <v-btn
          class="link non-text-transformation"
          color="black"
          outlined
          tile
          @click="closeAndGoBack"
        >
          {{ $t('TARIFF_STEP_CHANGE_OFFER_TYPE_CANCEL') }}
        </v-btn>
        <v-btn
          class="link non-text-transformation"
          color="primary"
          tile
          @click="closeAndContinue"
        >
          {{ $t('TARIFF_STEP_CHANGE_OFFER_TYPE_CONTINUE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'

export default {
  name: 'AdditionalInfoRequiredDialog',
  props: {
    showDialog: {
      type: Boolean,
    },
  },
  inject: ['closeInfoRequiredDialog'],
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM, 'canEditOffer']),
    offerType() {
      return this[GET_OFFER_ITEM]('type')
    },
  },
  methods: {
    closeAndContinue() {
      this.closeInfoRequiredDialog(true)
    },
    closeAndGoBack() {
      this.closeInfoRequiredDialog(false)
    },
  },
  watch: {
    showDialog() {
      if (this.showDialog && !this.canEditOffer) {
        this.closeInfoRequiredDialog(true)
      }
    },
  },
}
</script>
